import CaseTypesApi from "@/api/case-types";
import {
  Option,
  SelectBox,
  SelectBoxProps,
} from "@monolith-forensics/monolith-ui";
import { useQuery } from "@tanstack/react-query";

type CaseTypeRecord = {
  case_type_id: number;
  case_type: string;
};

export type CaseTypeSelectorProps = Omit<
  SelectBoxProps,
  | "data"
  | "renderOption"
  | "OptionTooltip"
  | "searchFn"
  | "onScroll"
  | "searchable"
  | "loading"
  | "defaultValue"
  | "value"
> & {
  defaultValue?: Option;
  value?: Option;
};

export const CaseTypeSelector: React.FC<CaseTypeSelectorProps> = (props) => {
  const { data, isLoading } = useQuery({
    queryKey: ["case-types", "list"],
    queryFn: () => CaseTypesApi.getCaseTypes(),
  });

  const records: CaseTypeRecord[] = data || [];

  // Combine number and name in label for client-side search by either
  const options: Option[] = records.map((item) => ({
    label: `${item.case_type}`,
    value: item.case_type,
    data: item,
  }));

  return (
    <SelectBox
      placeholder="Select or search for a case type..."
      {...props}
      data={options}
      searchable={true}
      loading={isLoading}
    />
  );
};
